import { FC, SVGProps } from 'react';
import { SvgIcon } from '../SvgIcon';

export const FavoriteIconFull: FC<SVGProps<SVGSVGElement>> = props => {
	return (
		<SvgIcon className={`full-favorite-icon`} height={16} width={16} {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12.8 15.2381C12.6456 15.2381 12.4912 15.1954 12.356 15.1101L8.00003 12.3444L3.64403 15.1101C3.36563 15.2869 3.00003 15.2808 2.72883 15.0918C2.45763 14.9036 2.33843 14.5737 2.43123 14.2667L3.90163 9.36457L0.234429 5.872C0.00562933 5.65486 -0.0631707 5.32648 0.0608293 5.04229C0.184829 4.75733 0.476829 4.57143 0.800029 4.57143H5.10563L7.28403 0.421334C7.55523 -0.0944752 8.44483 -0.0944752 8.71603 0.421334L10.8944 4.57143H15.2C15.5232 4.57143 15.8152 4.75733 15.9392 5.04229C16.0632 5.32648 15.9944 5.65486 15.7656 5.872L12.0984 9.36457L13.5688 14.2667C13.6616 14.5737 13.5424 14.9036 13.2712 15.0918C13.1312 15.1893 12.9656 15.2381 12.8 15.2381Z'
				fill='currentColor'
			/>
		</SvgIcon>
	);
};
